export function TermsFooter() {
  return (
    <div className="text-muted-foreground *:[a]:hover:text-primary text-center text-xs text-balance *:[a]:underline *:[a]:underline-offset-4 p-4">
      By clicking continue, you agree to our <a href="#">Terms of Service</a> and{" "}
      <a href="#">Privacy Policy</a>.
    </div>
  )
}
